import type { ErrorComponentProps } from "@tanstack/react-router";
import { ErrorView } from "@/components/error/error-view";

export function RootErrorComponent({ error, reset }: ErrorComponentProps) {
  return (
    <ErrorView
      error={error}
      onRetry={reset}
      title="Something went wrong"
      logMessage="Root error boundary triggered"
    />
  );
}
